import { singularize, underscore } from 'inflected';
import { useMemo } from 'react';

const useCollectionTypeName = (type = '') =>
  useMemo(() => {
    switch (type) {
      case 'child-journals':
        return 'Child Journal';
      case 'family-journals':
        return 'Family Memoir';
      case 'personal-journals':
        return 'Personal Journal';
      case 'memoirs':
        return 'Memoir';
      case 'other-journals':
      case 'custom':
        return 'Memoir';
      default:
        return singularize(underscore(type));
    }
  }, [type]);

export default useCollectionTypeName;
